import { h } from 'preact';
import { createElement } from 'lucide';
import * as icons from 'lucide';

interface ControlsBarProps {
  showReset?: boolean;
  showFullscreen?: boolean;
  showKeybinds?: boolean;
  showFocusLock?: boolean;
  focusLockActive?: boolean;
  onReset?: () => void;
  onFullscreen?: () => void;
  onToggleKeybinds?: () => void;
  onToggleFocusLock?: () => void;
}

export const ControlsBar = ({
  showReset = true,
  showFullscreen = true,
  showKeybinds = true,
  showFocusLock = true,
  focusLockActive = false,
  onReset,
  onFullscreen,
  onToggleKeybinds,
  onToggleFocusLock,
}: ControlsBarProps) => {
  const renderIcon = (iconName: string): h.JSX.Element => {
    const icon = (icons as any)[iconName] ?? icons.Camera;
    const svg = createElement(icon, {
      width: 18,
      height: 18,
      stroke: 'currentColor',
      'stroke-width': 1.8,
    });
    return <span dangerouslySetInnerHTML={{ __html: svg.outerHTML }} />;
  };

  return (
    <div class="visualizer-controls-bar">
      {showReset && (
        <button
          class="visualizer-control-btn"
          onClick={onReset}
          title="Reset view"
        >
          {renderIcon('RotateCcw')}
        </button>
      )}

      {showKeybinds && (
        <button
          class="visualizer-control-btn"
          onClick={onToggleKeybinds}
          title="Toggle keyboard shortcuts"
        >
          {renderIcon('Keyboard')}
        </button>
      )}

      {showFocusLock && (
        <button
          class={`visualizer-control-btn ${focusLockActive ? 'active' : ''}`}
          onClick={onToggleFocusLock}
          title="Focus Lock (Box-select zoom)"
          style={focusLockActive ? { background: '#007bff', color: 'white' } : {}}
        >
          {renderIcon('Scan')}
        </button>
      )}

      {showFullscreen && (
        <button
          class="visualizer-control-btn"
          onClick={onFullscreen}
          title="Toggle fullscreen"
        >
          {renderIcon('Maximize2')}
        </button>
      )}
    </div>
  );
};
